import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { AppError, BaseLayer, DataLayer, ProjectTemplate } from '@core/api';

export const configApiActions = createActionGroup({
  source: 'Config/API',
  events: {
    'Add Project Templates': props<{ templates: ProjectTemplate[] }>(),
    'Refresh Data Layers': emptyProps(),
    'Refresh Data Layers Success': props<{ basemaps: BaseLayer[]; layers: DataLayer[] }>(),
    'Refresh Data Layers Fail': props<{ error: AppError }>(),
  },
});
